const lang = {
  'ja': 'ja'
}[window.navigator.language || navigator.userLanguage] || 'en'

export const externalLinkDatas = {
  'expert': 'https://expert.inherinext.com/',
  'inherinext': {
    'ja': 'https://edge.inherinext.com/',
    'en': 'https://edge.inherinext.com/'
  }[lang]
}



// WEBPACK FOOTER //
// ./src/constants/global/data.js